import { useDispatch, useSelector } from "react-redux";
import { useSetUserMetaDataMutation } from "generated/graphql";
import { State } from "../store";
import {
  UserMetaDataState,
  updateUserMeta,
  defaultSessionMetadata
} from "store/userMeta";

/**
 * This hook should be used for STORING userMeta, but does not take
 * responsibility for returning the userMeta.
 * To access the userMeta information, use the store's getUserMeta action.
 */

export type SetUserMetaFn = (
  update: Partial<UserMetaDataState>,
  saveToApi?: boolean
) => void;

export const useUserMeta = (): [SetUserMetaFn] => {
  const dispatch = useDispatch();
  const userMeta: State["userMeta"] = useSelector(
    (state: State) => state.userMeta
  );
  const [, saveUserMetaToApi] = useSetUserMetaDataMutation();

  const setUserMeta: SetUserMetaFn = (update, saveToApi = true) => {
    let newMeta = { ...userMeta, ...update };
    dispatch(updateUserMeta(newMeta));

    if (saveToApi) {
      Object.keys(defaultSessionMetadata).forEach(key => {
        delete newMeta[key as keyof UserMetaDataState];
      });
      delete newMeta["tables" as keyof UserMetaDataState];

      saveUserMetaToApi({ input: newMeta });
    }
  };

  return [setUserMeta];
};
